import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-help',
  template: `
    <app-bar flTrackingSection="SubnavHelp">
      <app-bar-item link="/support/categories"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="GetSupport"
      >
        Get Support
      </app-bar-item>
      <app-bar-item link="/info/how-it-works"
        [exactLink]="true"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="HowItWorks"
      >
        How Freelancer.com Works
      </app-bar-item>
      <app-bar-item link="/faq/view.php"
        [exactLink]="true"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="FAQ"
      >
        Frequently Asked Questions
      </app-bar-item>
      <app-bar-item link="/feesandcharges"
        [exactLink]="true"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="FeesAndCharges"
      >
        Fees and Charges
      </app-bar-item>
      <app-bar-item link="/dispute/disputeslist.php"
        [exactLink]="true"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="Disputes"
      >
        Disputes
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation help bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryHelpComponent {
  ButtonColor = ButtonColor;
}
